import { BUModel } from "../models/BUModel";
import API, { client } from "./API";

const BUService = {
  async getAllBUs() {
    const response = await API().get("BU", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getAllBUsBySBU(sbuName: string) {
    const response = await API().get(`BU/GetBUBySBUName/${sbuName}`, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularBU(bu_id: number) {
    const response = await API().get("BU");
    return response.data.filter((cur_bu: BUModel) => cur_bu.buid === bu_id)[0];
  },
  async createBU(buData: BUModel, id?: number) {
    // const { buuserId, ...rest } = buData;
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `BU/${id}` : "BU",
        data: buData,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default BUService;
